/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import IntraOPRecovery from './intra-op-recovery';
import IntraOPRecoveryDetail from './intra-op-recovery-detail';
import IntraOPRecoveryUpdate from './intra-op-recovery-update';
import IntraOPRecoveryDeleteDialog from './intra-op-recovery-delete-dialog';

const IntraOPRecoveryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<IntraOPRecovery />} />
    <Route path="new" element={<IntraOPRecoveryUpdate />} />
    <Route path=":id">
      <Route index element={<IntraOPRecoveryDetail />} />
      <Route path="edit" element={<IntraOPRecoveryUpdate />} />
      <Route path="delete" element={<IntraOPRecoveryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default IntraOPRecoveryRoutes;
